const headerSize = 40;

export const SIZES_V2 = {
  HEADER_SIZE: headerSize,
  MOBILE_HEADER_OFFSET: headerSize / 3,
  RACETRACK_MOBILE_FOOTER_OFFSET: 5,
} as const;
